import {
    fetchMonitoredDocumentMarkdownAction,
    fetchMonitoredDocumentVersionAction,
    fetchMonitoredDocumentVersionsAction,
} from '../../state/actions/MonitoredDocumentActions';

import Component from './MonitoredDocumentViewer.component.jsx';
import { connect } from 'react-redux';
import fromState from '../../state/selectors';

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    return {
        fetchingMarkdown: fromState.MonitoredDocumentMarkdown.isFetching(state),
        fetchedMarkdown: fromState.MonitoredDocumentMarkdown.isFetched(state),
        failedMarkdown: fromState.MonitoredDocumentMarkdown.hasFailed(state),
        markdown: fromState.MonitoredDocumentMarkdown.getMonitoredDocumentMarkdown(state),
        fetchingMonitoredDocumentVersion: fromState.MonitoredDocumentVersion.isFetching(state),
        fetchedMonitoredDocumentVersion: fromState.MonitoredDocumentVersion.isFetched(state),
        failedMonitoredDocumentVersion: fromState.MonitoredDocumentVersion.hasFailed(state),
        monitoredDocumentVersion:
            fromState.MonitoredDocumentVersion.getMonitoredDocumentVersion(state),
        monitoredDocumentVersions:
            fromState.MonitoredDocumentVersions.getMonitoredDocumentVersions(state),
        fetchingMonitoredDocumentVersions: fromState.MonitoredDocumentVersions.isFetching(state),
        fetchedMonitoredDocumentVersions: fromState.MonitoredDocumentVersions.isFetched(state),
        failedMonitoredDocumentVersions: fromState.MonitoredDocumentVersions.hasFailed(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetchMonitoredDocumentMarkdown: () =>
            dispatch(fetchMonitoredDocumentMarkdownAction(ownProps.documentId)),
        fetchMonitoredDocumentVersion: () =>
            dispatch(fetchMonitoredDocumentVersionAction(ownProps.documentId, ownProps.versionId)),
        fetchMonitoredDocumentVersions: () =>
            dispatch(fetchMonitoredDocumentVersionsAction(ownProps.documentId)),
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    return {
        ...ownProps,
        ...stateProps,
        onInitialLoad: dispatchProps.fetchMonitoredDocumentVersion,
        loadVersions: dispatchProps.fetchMonitoredDocumentVersions,
        loadMarkdown: dispatchProps.fetchMonitoredDocumentMarkdown,
    };
};

// EXPORT CONTAINER
export default connect(mapStateToProps, mapDispatchToProps, mergeProps, { forwardRef: true })(
    Component
);
